import React, { useState, useEffect, Dispatch, SetStateAction } from "react";
import { useApi } from "../../../../hooks/useApi";
import LineBtn from "../../../Button/LineBtn";
import Flex from "../../../DefaultStyles/Flex";
import Loader from "../../../DefaultStyles/Loader";
import DropDown, { OptionType } from "../../../Filters/DropDown";
import Search from "../../../Filters/Search";
import SearchDropdown from "../../../Filters/SearchDropdown";
import { PartyInfoFilterContainer } from "../../Party/PartyInfo/PartyInfoFilter";
import CommentModal from "../UserDetail/CommentModal/CommentModal";

interface CommentFilterProps {
  pageResetEvent: () => void;
  setFilter: Dispatch<SetStateAction<{ value: string; type: string }>>;
  fetchData: () => void;
  setTagFilter: Dispatch<SetStateAction<string>>;
}

const commentFilterOptions: OptionType[] = [
  { value: "uid", label: "UID" },
  { value: "name", label: "이름" },
  { value: "nickname", label: "닉네임" },
  { value: "phone", label: "전화번호" },
  { value: "writer", label: "작성자" },
];

export default function CommentFilter({
  pageResetEvent,
  setFilter,
  fetchData,
  setTagFilter,
}: CommentFilterProps) {
  const [dropDownValue, setDropDownValue] = useState<OptionType>({
    value: "",
    label: "선택",
  });
  const [searchValue, setSearchValue] = useState<string | undefined>("");
  const [tagBoxClick, setTagBoxClick] = useState(false); // 태그 검색 박스 클릭
  const [tagDropdown, setTagDropdown] = useState<OptionType>({
    value: "",
    label: "태그 검색",
  });
  const [tagList, setTagList] = useState<OptionType[]>([]);
  const [searchTag, setSearchTag] = useState<string | undefined>(""); // 태그 검색 값
  const [commentWriteModal, setCommentWriteModal] = useState(false); // 코멘트 입력 모달

  // 태그 리스트
  const { response: tagRes, loading: tagLoading } = useApi({
    method: "get",
    url: tagBoxClick ? `comment/category` : undefined,
  });

  console.log(searchTag);

  useEffect(() => {
    if (tagRes?.status === 200) {
      const serverList: { category: string }[] = tagRes.data;
      let dropdownList = [];

      for (let i = 0; i < serverList.length; i++) {
        const el = serverList[i];

        dropdownList.push({
          value: `${i}`,
          label: `${el.category}`,
        });
      }

      setTagList(dropdownList);
    }
  }, [tagRes]);

  useEffect(() => {
    if (tagDropdown?.value !== "") {
      setSearchValue(tagDropdown?.value);
    }
  }, [tagDropdown?.value]);

  useEffect(() => {
    if (searchValue !== "") {
      setFilter({
        value: `${searchValue}`,
        type: `${dropDownValue?.value}`,
      });
    }
  }, [searchValue]);

  useEffect(() => {
    if (searchTag !== "") {
      setTagFilter(`${searchTag}`);
    }
  }, [searchTag]);

  return (
    <PartyInfoFilterContainer maxWidth={1200}>
      <>
        <Flex gapSize={10}>
          <DropDown
            isDisabled={false}
            setDropDownValue={setDropDownValue}
            dropdownValue={dropDownValue}
            boxWidth={180}
            optionList={commentFilterOptions}
          />

          <Search
            placeholder="입력"
            setSearchValue={setSearchValue}
            isDisabled={dropDownValue?.value === ""}
            pageResetEvent={() => pageResetEvent()}
            inputType={
              dropDownValue?.value === "phone" || dropDownValue?.value === "uid"
                ? "number"
                : undefined
            }
          />
        </Flex>

        <Flex gapSize={10}>
          <LineBtn
            btnText="코멘트 입력"
            icon="edit"
            btnClickEvent={() => setCommentWriteModal(true)}
            btnHeight={38}
          />

          <div onClick={() => setTagBoxClick(true)}>
            <SearchDropdown
              placeholder="태그 검색"
              searchValue={searchTag}
              setSearchValue={setSearchTag}
              keywordList={tagList}
              saveLabel={true}
            />
          </div>
        </Flex>

        {tagLoading && <Loader />}

        {/* 코멘트 입력 모달  */}
        {commentWriteModal && (
          <CommentModal
            closeEvent={() => setCommentWriteModal(false)}
            confirmEvent={() => fetchData()}
            type="input"
          />
        )}
      </>
    </PartyInfoFilterContainer>
  );
}
